var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex-ns" }, [
    _c("div", { staticClass: "w-100 flex flex-wrap" }, [
      _c("div", { staticClass: "form-group pr2-ns w-100 w-50-ns" }, [
        _c("label", { staticClass: "control-label" }, [
          _vm._v(_vm._s(_vm.strings["shipping_name"]))
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.alternative.name,
              expression: "alternative.name"
            }
          ],
          staticClass: "form-control placeholder-no-fix",
          class: { errorcontrol: _vm.emptyName },
          attrs: {
            type: "text",
            autocomplete: "false",
            placeholder: _vm.strings["shipping_name"],
            name: "name",
            maxlength: "34"
          },
          domProps: { value: _vm.alternative.name },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.alternative, "name", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _vm.nameCheck == false
          ? _c(
              "div",
              {
                staticClass:
                  "form-group w-100 washed-yellow bg-dark-red ph3 pv2"
              },
              [_vm._v(_vm._s(_vm.strings["input_error_only_chars"]))]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group pr2-ns w-100 w-50-ns" }, [
        _c("label", { staticClass: "control-label" }, [
          _vm._v(_vm._s(_vm.strings["shipping_surname"]))
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.alternative.surname,
              expression: "alternative.surname"
            }
          ],
          staticClass: "form-control placeholder-no-fix",
          class: { errorcontrol: _vm.emptySurname },
          attrs: {
            type: "text",
            autocomplete: "false",
            placeholder: _vm.strings["shipping_surname"],
            name: "surname",
            maxlength: "34"
          },
          domProps: { value: _vm.alternative.surname },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.alternative, "surname", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _vm.surnameCheck == false
          ? _c(
              "div",
              {
                staticClass:
                  "form-group w-100 washed-yellow bg-dark-red ph3 pv2"
              },
              [_vm._v(_vm._s(_vm.strings["input_error_only_chars"]))]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group pr2-ns w-100" }, [
        _c("label", { staticClass: "control-label" }, [
          _vm._v(_vm._s(_vm.strings["company_name"] || "Nome Azienda"))
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.alternative.company_name,
              expression: "alternative.company_name"
            }
          ],
          staticClass: "form-control placeholder-no-fix",
          attrs: {
            type: "text",
            autocomplete: "false",
            placeholder:
              _vm.strings["company_name"] || "Nome Azienda (opzionale)",
            name: "company_name",
            maxlength: "34"
          },
          domProps: { value: _vm.alternative.company_name },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.alternative, "company_name", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _vm.companyNameCheck == false
          ? _c(
              "div",
              {
                staticClass:
                  "form-group w-100 washed-yellow bg-dark-red ph3 pv2"
              },
              [_vm._v(_vm._s(_vm.strings["input_error_only_chars"]))]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group pr2-ns w-100 w-50-ns" }, [
        _c("label", { staticClass: "control-label" }, [
          _vm._v(_vm._s(_vm.strings["shipping_address"]))
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.alternative.address,
              expression: "alternative.address"
            }
          ],
          staticClass: "form-control placeholder-no-fix",
          attrs: {
            type: "text",
            placeholder: _vm.strings["shipping_address"],
            name: "location",
            maxlength: "34",
            minlength: "6"
          },
          domProps: { value: _vm.alternative.address },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.alternative, "address", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _vm.addressCheck == false
          ? _c(
              "div",
              {
                staticClass:
                  "form-group w-100 washed-yellow bg-dark-red ph3 pv2"
              },
              [_vm._v(_vm._s(_vm.strings["only_latin_charsets"]))]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.addressTooShort
          ? _c(
              "div",
              {
                staticClass:
                  "form-group w-100 washed-yellow bg-dark-red ph3 pv2"
              },
              [_vm._v(_vm._s(_vm.strings["adress_limit_char"]))]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group pr2-ns w-100 w-50-ns" }, [
        _c("label", { staticClass: "control-label" }, [
          _vm._v(_vm._s(_vm.strings["shipping_zip_code"]))
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.alternative.zip_code,
              expression: "alternative.zip_code"
            }
          ],
          staticClass: "form-control placeholder-no-fix",
          attrs: {
            type: "text",
            autocomplete: "false",
            placeholder: _vm.strings["shipping_zip_code"],
            name: "zipcode",
            maxlength: "15"
          },
          domProps: { value: _vm.alternative.zip_code },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.alternative, "zip_code", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _vm.zipCodeCheck == false
          ? _c(
              "div",
              {
                staticClass:
                  "form-group w-100 washed-yellow bg-dark-red ph3 pv2"
              },
              [_vm._v(_vm._s(_vm.strings["only_latin_charsets"]))]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group pr2-ns w-100 w-50-ns" }, [
        _c("label", { staticClass: "control-label" }, [
          _vm._v(_vm._s(_vm.strings["shipping_city"]))
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.alternative.city,
              expression: "alternative.city"
            }
          ],
          staticClass: "form-control placeholder-no-fix",
          attrs: {
            type: "text",
            autocomplete: "false",
            placeholder: _vm.strings["shipping_city"],
            name: "city",
            maxlength: "34"
          },
          domProps: { value: _vm.alternative.city },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.alternative, "city", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _vm.cityCheck == false
          ? _c(
              "div",
              {
                staticClass:
                  "form-group w-100 washed-yellow bg-dark-red ph3 pv2"
              },
              [_vm._v(_vm._s(_vm.strings["input_error_only_chars"]))]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group pr2-ns w-100 w-50-ns" }, [
        _c("label", { staticClass: "control-label" }, [
          _vm._v(_vm._s(_vm.strings["shipping_district"]))
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.alternative.district,
              expression: "alternative.district"
            }
          ],
          staticClass: "form-control placeholder-no-fix",
          attrs: {
            type: "text",
            autocomplete: "false",
            placeholder: _vm.strings["shipping_district"],
            name: "district",
            maxlength: "34"
          },
          domProps: { value: _vm.alternative.district },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.alternative, "district", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _vm.districtCheck == false
          ? _c(
              "div",
              {
                staticClass:
                  "form-group w-100 washed-yellow bg-dark-red ph3 pv2"
              },
              [_vm._v(_vm._s(_vm.strings["input_error_only_chars"]))]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group pr2-ns w-100 w-50-ns" }, [
        _c("label", { staticClass: "control-label" }, [
          _vm._v(_vm._s(_vm.strings["shipping_country"]))
        ]),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.alternative.country,
                expression: "alternative.country"
              }
            ],
            staticClass: "form-control",
            attrs: { name: "country_id", autocomplete: "false" },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.alternative,
                  "country",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              }
            }
          },
          [
            _c(
              "option",
              { attrs: { selected: "", disabled: "", value: "---" } },
              [_vm._v(_vm._s(_vm.strings["shipping_country"]))]
            ),
            _vm._v(" "),
            _vm._l(_vm.countries, function(option) {
              return _c(
                "option",
                {
                  key: option.id,
                  domProps: {
                    value: option.iso_code,
                    selected: option.iso_code == _vm.alternative.country
                  }
                },
                [_vm._v(_vm._s(option.name))]
              )
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group pr2-ns w-100 w-50-ns" }, [
        _c("label", { staticClass: "control-label" }, [
          _vm._v(_vm._s(_vm.strings["shipping_telephone"]))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.telephonePrefix,
                expression: "telephonePrefix"
              }
            ],
            staticClass: "form-control placeholder-no-fix",
            staticStyle: {
              width: "80px",
              "margin-right": "8px",
              "background-color": "#f5f5f5",
              cursor: "not-allowed"
            },
            attrs: {
              type: "text",
              autocomplete: "false",
              placeholder: "+000",
              name: "telephone_prefix",
              readonly: ""
            },
            domProps: { value: _vm.telephonePrefix },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.telephonePrefix = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.telephoneNumber,
                expression: "telephoneNumber"
              }
            ],
            staticClass: "form-control placeholder-no-fix flex-1",
            attrs: {
              type: "text",
              autocomplete: "false",
              placeholder: _vm.getTelephoneNumberPlaceholder(),
              name: "telephone_number"
            },
            domProps: { value: _vm.telephoneNumber },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.telephoneNumber = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _vm.telephoneCheck == false
          ? _c(
              "div",
              {
                staticClass:
                  "form-group w-100 washed-yellow bg-dark-red ph3 pv2"
              },
              [_vm._v(_vm._s(_vm.strings["input_error_only_numbers"]))]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group w-100" }, [
        _c(
          "button",
          {
            staticClass: "w-40 confirmbutton",
            attrs: { disabled: _vm.checked === false },
            on: {
              click: function($event) {
                return _vm.$emit("check")
              }
            }
          },
          [_vm._v(_vm._s(_vm.strings["confirm"]))]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }